module.exports = __webpack_public_path__ + "static/img/technology_1.e890a6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology/technology_1.jpg
// module id = KT/C
// module chunks = 0